import { render, staticRenderFns } from "./serviceoption.vue?vue&type=template&id=50307450&scoped=true&"
import script from "./serviceoption.vue?vue&type=script&lang=js&"
export * from "./serviceoption.vue?vue&type=script&lang=js&"
import style0 from "./serviceoption.vue?vue&type=style&index=0&id=50307450&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50307450",
  null
  
)

export default component.exports